import { render, staticRenderFns } from "./SPFreelancerClientInfo.vue?vue&type=template&id=0565d576&scoped=true"
import script from "./SPFreelancerClientInfo.vue?vue&type=script&lang=js"
export * from "./SPFreelancerClientInfo.vue?vue&type=script&lang=js"
import style0 from "./SPFreelancerClientInfo.vue?vue&type=style&index=0&id=0565d576&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0565d576",
  null
  
)

export default component.exports